module.exports = __webpack_public_path__ + "img/love_you_gesture.5f194740.gif";